import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import dzrLogo from "../assets/dzr-logo.png";

const API_URL = process.env.REACT_APP_API_URL || "";

export default function ForceChangePassword() {
  const navigate = useNavigate();
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!oldPassword || !newPassword || !confirmPassword) {
      setMessage("Compila tutti i campi.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage("Le nuove password non coincidono.");
      return;
    }

    setSaving(true);

    try {
      const res = await fetch(`${API_URL}/api/change-password/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access") || ""}`,
        },
        body: JSON.stringify({
          old_password: oldPassword,
          new_password: newPassword,
        }),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        const detail = Array.isArray(data.detail) ? data.detail.join(" ") : data.detail;
        setMessage(detail || "Errore durante il cambio password.");
        return;
      }

      setMessage("Password aggiornata correttamente.");
      navigate("/", { replace: true });
    } catch (err) {
      setMessage("Errore di connessione. Riprova.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        <div style={brandHeaderStyle}>
          <img src={dzrLogo} alt="Dallo Zio Roby" style={logoStyle} />
          <div>
            <div style={brandNameStyle}>Gestionale Dallo Zio Roby</div>
            <div style={brandSubStyle}>Accesso sicuro</div>
          </div>
        </div>

        <h1 style={titleStyle}>Cambio password obbligatorio</h1>
        <p style={introStyle}>
          La password ricevuta è provvisoria. Per proteggere il tuo account,
          impostane una personale prima di continuare.
        </p>

        <form onSubmit={handleSubmit}>
          <label>Vecchia password</label>
          <input type="password" value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} style={inputStyle} />

          <label>Nuova password</label>
          <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} style={inputStyle} />

          <label>Conferma nuova password</label>
          <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} style={inputStyle} />

          {message && <div style={{ margin: "12px 0", color: message.includes("correttamente") ? "#166534" : "#b91c1c" }}>{message}</div>}

          <button type="submit" disabled={saving} style={buttonStyle}>
            {saving ? "Salvataggio..." : "Aggiorna password"}
          </button>
        </form>
      </div>
    </div>
  );
}

const pageStyle = {
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 20,
  background:
    "radial-gradient(circle at top left, rgba(122,17,17,0.16), transparent 34%), linear-gradient(135deg, #f7f1e8 0%, #ede4d8 48%, #f9f6f1 100%)",
};

const cardStyle = {
  width: "100%",
  maxWidth: 500,
  background: "rgba(255,255,255,0.96)",
  borderRadius: 24,
  padding: 32,
  border: "1px solid rgba(122,17,17,0.14)",
  boxShadow: "0 22px 55px rgba(80, 31, 20, 0.20)",
};

const brandHeaderStyle = {
  display: "flex",
  alignItems: "center",
  gap: 14,
  paddingBottom: 18,
  marginBottom: 22,
  borderBottom: "1px solid rgba(122,17,17,0.12)",
};

const logoStyle = {
  width: 72,
  height: 72,
  borderRadius: "50%",
  objectFit: "cover",
  boxShadow: "0 8px 20px rgba(122,17,17,0.22)",
};

const brandNameStyle = {
  fontSize: 20,
  fontWeight: 800,
  color: "#4b0b0b",
  lineHeight: 1.1,
};

const brandSubStyle = {
  marginTop: 4,
  fontSize: 13,
  textTransform: "uppercase",
  letterSpacing: 1.2,
  color: "#8a6b4d",
  fontWeight: 700,
};

const titleStyle = {
  margin: "0 0 10px",
  color: "#7a1111",
  fontSize: 34,
  lineHeight: 1.05,
  fontWeight: 900,
};

const introStyle = {
  color: "#4b5563",
  lineHeight: 1.55,
  marginBottom: 22,
};

const inputStyle = {
  width: "100%",
  boxSizing: "border-box",
  margin: "6px 0 14px",
  padding: "13px 14px",
  borderRadius: 12,
  border: "1px solid #d8c7b8",
  fontSize: 16,
  outlineColor: "#7a1111",
  background: "#fffdfb",
};

const buttonStyle = {
  width: "100%",
  marginTop: 10,
  padding: "14px 16px",
  borderRadius: 12,
  border: "none",
  background: "linear-gradient(135deg, #7a1111 0%, #9d1414 55%, #5c0909 100%)",
  color: "#fff",
  fontWeight: 800,
  fontSize: 16,
  cursor: "pointer",
  boxShadow: "0 12px 24px rgba(122,17,17,0.26)",
};
